import { render, staticRenderFns } from "./PartnerChoice.vue?vue&type=template&id=0da43236"
import script from "./PartnerChoice.vue?vue&type=script&lang=js"
export * from "./PartnerChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports